import React from 'react';
import { Switch, Form } from 'antd';

const FormSwitch = ({ label, name, rules, ...rest }) => {
  return (
    <Form.Item label={label} name={name} rules={rules} valuePropName="checked">
      <Switch {...rest} />
    </Form.Item>
  );
};

export default FormSwitch;
